module.exports = __webpack_public_path__ + "static/media/reports.2de7e897.svg";